import React from "react";
import "./Messenger.css";
function Messenger(){
    return <div className="messenger">Messenger</div>;
}

export default Messenger;